<template>
  <ReviewDisplaySkeleton v-if="isPending" :limit />

  <ul v-else-if="reviews?.length" class="space-y-16 md:space-y-20">
    <li
      v-for="(review, index) in reviews"
      :key="review.id"
      class="overflow-hidden"
    >
      <UserComment :position="index" v-bind="review" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { Review } from '@backmarket/http-api/src/api-specs-reviews/types/review'

import { REVIEWS_LIST_DEFAULT_LENGTH } from '../../constants'
import UserComment from '../UserComment/UserComment.vue'

import ReviewDisplaySkeleton from './ReviewDisplaySkeleton.vue'

type ReviewsList = {
  reviews: Review[]
  isPending?: boolean
  limit?: number
}

withDefaults(defineProps<ReviewsList>(), {
  limit: REVIEWS_LIST_DEFAULT_LENGTH,
  isPending: false,
})
</script>
